import React from 'react';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Label,
  Row,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Form,
  FormFeedback,
  FormGroup,
  FormText,
  Input,
} from 'reactstrap';
import axios from '../utils/posAxios';
import StorageService from '../services/StorageService';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import { Redirect } from 'react-router';
import moment from 'moment-timezone';
import { MDBDataTableV5, MDBIcon } from 'mdbreact';
import '@fortawesome/fontawesome-free/css/all.min.css';
import classnames from 'classnames';
import { getUser, getUser_v2 } from '../utils/dropdownlist';
import { MdDone, MdWarning, MdModeEdit } from 'react-icons/md';
import { FaEdit } from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import Select from 'react-select';

class PaymentReport extends React.Component {
  _isMounted = true;
  paymentDetail = StorageService.getSession('PaymentReport');
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      isLoading: true,
      store_id:
        this.paymentDetail && this.paymentDetail.store_id
          ? this.paymentDetail.store_id
          : this.props.data.storeList[0].store_id,
      storeList: this.props.data.storeList,
      date:
        this.paymentDetail && this.paymentDetail.date
          ? this.paymentDetail.date
          : moment()
              .subtract(1, 'days')
              .tz('Asia/Singapore')
              .format('YYYY-MM-DD'),
      // fm_date:
      //   this.paymentDetail && this.paymentDetail.fm_date
      //     ? this.paymentDetail.fm_date
      //     : moment()
      //         .subtract(1, 'days')
      //         .tz('Asia/Singapore')
      //         .format('YYYY-MM-DD'),
      fm_date:
        this.paymentDetail && this.paymentDetail.fm_date
          ? this.paymentDetail.fm_date
          : moment().startOf('month').format('YYYY-MM-DD'),
      // to_date:
      //   this.paymentDetail && this.paymentDetail.to_date
      //     ? this.paymentDetail.to_date
      //     : moment()
      //         .subtract(1, 'days')
      //         .tz('Asia/Singapore')
      //         .format('YYYY-MM-DD'),
      to_date:
        this.paymentDetail && this.paymentDetail.to_date
          ? this.paymentDetail.to_date
          : moment().endOf('month').format('YYYY-MM-DD'),
      reportList: [],
      invoice_verify:
        this.paymentDetail && this.paymentDetail.invoice_verify
          ? this.paymentDetail.invoice_verify
          : false,
    };
  }

  componentDidMount() {
    if (this.paymentDetail) {
      this.getReport();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  changeHandler = e => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
    let data = this.paymentDetail ? this.paymentDetail : {};
    data[name] = value;
    StorageService.setSession('PaymentReport', data);
    this.paymentDetail = StorageService.getSession('PaymentReport');
  };

  storeHandler = e => {
    const { label, value } = e;
    this.setState({
      store_id: value,
    });
    let data = this.paymentDetail ? this.paymentDetail : {};
    data['store_id'] = value;
    StorageService.setSession('PaymentReport', data);
    this.paymentDetail = StorageService.getSession('PaymentReport');
  };

  checkHandler = e => {
    const { name, value } = e.target;
    this.setState({
      [name]: !this.state[name],
    });
    let data = this.paymentDetail ? this.paymentDetail : {};
    data[name] = value;
    StorageService.setSession('PaymentReport', data);
    this.paymentDetail = StorageService.getSession('PaymentReport');
  };

  getReport() {
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      fm_date: this.state.fm_date,
      to_date: this.state.to_date,
      verified: this.state.invoice_verify ? 1 : 0,
    };

    axios
      .post(url + ':3003/v2/order/report/payment', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        if (this._isMounted) {
          this.setState({
            reportList: result.data,
          });
        }
      })
      .catch(error => {
        alert(error);
      });
  }

  render() {
    let options = [
      ...this.state.storeList
        .reduce((r, o) => {
          let key = o.store_id;
          let item = { value: o.store_id, label: o.name };
          return r.set(key, item);
        }, new Map())
        .values(),
    ];
    return (
      <>
        <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />
        <Row>
          <Col>
            <h5>Payment Options Report</h5>
          </Col>
        </Row>
        <Row>
          <Col md={3}>
            <Label>Store</Label>
            {/* <Input
              className="ps-input-small"
              type="select"
              name="store_id"
              value={this.state.store_id}
              onChange={this.changeHandler}
            >
              {this.state.storeList.map(item => {
                return (
                  <option key={item.store_id} value={item.store_id}>
                    {item.name}
                  </option>
                );
              })}
            </Input> */}
            <Select
              options={options}
              value={options.filter(i => i.value == this.state.store_id)}
              name="store_id"
              onChange={this.storeHandler}
              menuPosition={'fixed'}
              required
            />
          </Col>
          <Col md={2}>
            <Label>Payment Date</Label>
            <Input
              className="ps-input-small"
              type="date"
              name="fm_date"
              onChange={this.changeHandler}
              value={this.state.fm_date}
            />
          </Col>
          <Col md={1}>
            <Label></Label>
            <p
              style={{
                padding: '0.4rem',
                textAlign: 'center',
                whiteSpace: 'nowrap',
              }}
            >
              To
            </p>
          </Col>
          <Col md={2}>
            <Label>Payment Date</Label>
            <Input
              className="ps-input-small"
              type="date"
              name="to_date"
              onChange={this.changeHandler}
              value={this.state.to_date}
            />
          </Col>
          <Col md={2} style={{ margin: 'auto' }}>
            <Label></Label>
            <FormGroup check>
              <Label check>
                <Input
                  type="checkbox"
                  name="invoice_verify"
                  checked={this.state.invoice_verify}
                  onChange={this.checkHandler}
                />
                Invoice Verified
              </Label>
            </FormGroup>
          </Col>
          <Col md={2} className="ps-margin-auto-desktop">
            <Button className="ps-input-small" onClick={() => this.getReport()}>
              Search
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>
            {this.state.reportList.length > 0 && (
              <Table className="ps-table tb-col-7 ps-responsive-table">
                <Thead>
                  <Tr>
                    {this.state.reportList.map(item => {
                      return (
                        <Th key={item.payment_mode}>{item.payment_mode}</Th>
                      );
                    })}
                  </Tr>
                </Thead>
                <Tbody>
                  {this.state.reportList.length > 0 && (
                    <Tr>
                      {this.state.reportList.map((item, index) => {
                        return <Td key={index}>{item.amount}</Td>;
                      })}
                    </Tr>
                  )}
                </Tbody>
              </Table>
            )}
          </Col>
        </Row>
      </>
    );
  }
}

export default PaymentReport;
